import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';

const ZONAS = [
  { code: 'NORTE', label: 'Norte' },
  { code: 'SUR', label: 'Sur' },
];

export default WithApp(function ModalCuotaJefePanettone(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);
  const [bosses, setBosses] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listBosses() {
    let response = await wsFindBy('base/boss-supervisor', { state: 'A', deleted: 'null' });
    if (response.success) setBosses(response.data);
  }

  useEffect(() => {
    if (bosses.length > 0 && cuota.base_boss_supervisor_id) {
      handleChange('base_boss_supervisor_id', String(cuota.base_boss_supervisor_id));
    }
  }, [bosses]);

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({
        ...(cuota.zona ? { zona: cuota.zona } : {}),
      });
      listBosses();
    }
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nueva cuota de jefe de venta Panetones`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/panettone_boss_supervisors'
        dataForce={{
          zona: dataChanging.zona,
          base_boss_supervisor_id: dataChanging.base_boss_supervisor_id,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={ZONAS}
          getOptionLabel={(item) => item.label}
          renderInput={(params) => (
            <TextField {...params} label="Zona" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('zona', item?.code); }}
          value={ZONAS.find((z) => z.code === dataChanging.zona) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={bosses}
          getOptionLabel={(item) => `${item.name}`}
          renderInput={(params) => (
            <TextField {...params} label="Jefe de venta" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('base_boss_supervisor_id', item?.id); }}
          value={bosses.find((b) => String(b.id) === String(dataChanging.base_boss_supervisor_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota (unidades)"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!cuota ? cuota.quota : ''}
          required
        />
      </Modal>
    </>
  );
});
